// 中文翻译文件
export default {
  // 通用
  common: {
    loading: '加载中...',
    submit: '提交',
    cancel: '取消',
    confirm: '确认',
    edit: '修改',
    delete: '删除',
    save: '保存',
    close: '关闭',
    search: '搜索',
    reset: '重置',
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    operation: '操作',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',
    remark: '备注',
    success: '操作成功',
    error: '操作失败',
    warning: '警告',
    info: '提示'
  },
  // 个人中心
  personalCenter: {
    pageTitle: '账户信息',
    username: '用户名',
    email: '邮箱',
    mobile: '手机号',
    password: '密码',
    language: '语言',
    languageDesc: '选择您偏好的通讯语言',
    lastLogin: '最后登录',
    notSet: '未设置',
    notBound: '未绑定',
    bound: '已绑定',
    goToBind: '去绑定',
    bind: '绑定',
    rebind: '重新绑定',
    modify: '修改',
    bindEmail: '绑定邮箱',
    bindMobile: '绑定手机号',
    rebindMobile: '重新绑定手机号',
    modifyUsername: '修改用户名',
    modifyPassword: '修改密码',
    verifyMethod: '验证方式',
    verifyAccount: '验证账号',
    mobileVerify: '手机验证',
    emailVerify: '邮箱验证',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    passwordPlaceholder: '6-12位',
    confirmPasswordPlaceholder: '请再次输入新密码',
    // 验证规则提示
    pleaseInputEmail: '请输入邮箱',
    emailFormatError: '邮箱格式不正确',
    pleaseInputMobile: '请输入手机号',
    mobileFormatError: '手机号格式不正确',
    pleaseInputUsername: '请输入用户名',
    usernameLengthError: '用户名长度 2-20 位',
    pleaseSelectVerifyMethod: '请选择验证方式',
    pleaseInputNewPassword: '请输入新密码',
    passwordLengthError: '长度 6-12 位',
    passwordComplexityError: '必须包含大小写+特殊字符',
    pleaseConfirmNewPassword: '请确认新密码',
    passwordMismatchError: '两次密码不一致',
    // 消息提示
    pleaseBindMobileOrEmail: '请先绑定手机或邮箱',
    pleaseInputVerifyAccount: '请先绑定验证账号',
    pleaseInputReceiverAccount: '请输入接收验证码的账号',
    getUserInfoFailed: '获取用户信息失败',
    languageChangeFailed: '语言切换失败'
  },
  // 代理用户详情
  agentUser: {
    phone: '手机号',
    accountBalance: '账户余额',
    depositAmount: '存款金额',
    email: '邮箱',
    registerTime: '注册时间',
    historyTradeAmount: '历史交易金额',
    tradeAccount: '交易账号',
    accountName: '账户名称',
    balance: '余额',
    tradeLeverage: '交易杠杆',
    historyTradeVolume: '历史交易量',
    addTime: '添加时间',
    loadDetailFailed: '加载详情失败',
    operateAccount: '操作账户',
    role: {
      1: '平台',
      2: '承包商',
      3: '特殊做市商',
      4: '普通做市商',
      5: '代理',
      6: '用户'
    }
  },
  // 取款
  withdraw: {
    pageTitle: '取款',
    withdraw: '取款',
    dialog: {
      title1: '取款',
      title2: '确认取款信息',
      amount: '取款金额',
      amountPlaceholder: '请输入取款金额',
      walletBalance: '钱包余额',
      deductionDetails: '扣除明细',
      type: '类型',
      originalBalance: '原余额',
      deductedAmount: '扣除金额',
      remaining: '剩余',
      totalDeducted: '合计扣除',
      channel: '渠道',
      withdrawAmount: '取款金额',
      walletAddress: '钱包地址',
      walletAddressPlaceholder: '请输入钱包地址',
      beneficiaryName: '收款人姓名',
      beneficiaryNamePlaceholder: '请输入收款人姓名',
      bankName: '银行名称',
      bankNamePlaceholder: '请输入银行名称',
      swiftCode: 'SWIFT代码',
      swiftCodePlaceholder: '请输入SWIFT代码',
      bankAddress: '银行地址',
      bankAddressPlaceholder: '请输入银行地址',
      bankAccount: '银行账号',
      bankAccountPlaceholder: '请输入银行账号',
      beneficiaryEnname: '收款人中文拼音名字(如:zhangsan)',
      beneficiaryEnnamePlaceholder: '请输入收款人中文拼音名字',
      bankTipsTitle: '温馨提示',
      bankTipsContent: '建议使用工商银行、中国银行、建设银行、招商银行、邮政储蓄银行、交通银行等大型商业银行，村镇商业银行等可能无法到账。仅支持单币种银联卡。单币种银联卡是指卡标识只有银联的借记卡，如果有银联加VISA或MasterCard一起标识的无法到账，同时为保证取款正常，请使用本人银行卡。',
      nextStep: '下一步',
      confirmWithdraw: '确认取款',
      submitSuccess: '取款申请已提交',
    },
    wallet: {
      feeHandling: '手续费',
      pointDiff: '点差佣金',
      service: '服务费',
      risk: '风险金',
      profit: '盈亏',
      headPosition: '盈亏',
      available: '可用余额',
    },
    table: {
      channelName: '渠道名称',
      channelFee: '渠道费用',
      apiUrl: '接口地址',
      apiAppid: '接口appid',
      status: '状态',
    },
  },
}
